import React from "react";
import { useTranslation } from "react-i18next";
import Colors from "../../../../../themes/Colors";

const STATUS_COLORS = {
  active: Colors.green,
  next: Colors.primary,
  pending: Colors.atention,
  payment_pending: Colors.red,
  previous: "#9aa0a6",
  archived: "#9aa0a6",
};

const NEW_VERSION_COLOR = Colors.atention;

const CampaignBadges = ({ campaign, state, statusLabel }) => {
  const { t } = useTranslation();
  const showNewVersion = !!campaign.new_ssp && campaign.status !== "proposal";
  const statusColor = STATUS_COLORS[state] || "#9aa0a6";

  return (
    <div className="campaignCard__badges">
      {showNewVersion && (
        <span
          className="campaignCard__pill"
          style={{
            color: NEW_VERSION_COLOR,
            borderColor: NEW_VERSION_COLOR,
            backgroundColor: `${NEW_VERSION_COLOR}14`,
          }}
        >
          {t("New version")}
        </span>
      )}
      {statusLabel && (
        <span
          className="campaignCard__pill"
          style={{
            color: statusColor,
            borderColor: statusColor,
            backgroundColor: `${statusColor}14`,
          }}
        >
          {statusLabel}
        </span>
      )}
    </div>
  );
};

export default CampaignBadges;
